// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"0fe95c44","152":"2c22c43a","198":"99fca25a","345":"8bfb174c","362":"e83e6b87","404":"3ac5f455","480":"8e312d3a","485":"06e06f08","541":"56d518ab","549":"2c9abd0d","579":"5025c982","622":"12771674","638":"c34c2827","639":"07d6bcac","757":"d7624f1e","854":"10515221"}[chunkId] + ".chunk.js";
};